export default function FirstHolyCommunionPage() {
    return (
        <div class="flex justify-center min-h-screen">
            <div class="text-center max-w-2xl p-6">
                <h1 className="text-3xl font-bold text-center my-6">First Holy Communion and Reconciliation</h1>
                <h2 class="text-2xl font-semibold text-blue-800 my-6">Enrolment takes place during Advent (December) each year</h2>
                <p class="text-base text-black mb-6">
                    Our Parish Community gives extra support to our Catholic children in Year 4, and to their families, and together we help
                    to deepen their understanding about the Church.  We focus on the gift of God’s forgiveness in Reconciliation/Confession,
                    on God’s gift of Jesus in Holy Communion – His Body and Blood seen at the altar, in the tabernacle and at Holy Communion
                    during Mass.  As part of family preparation for receiving these gifts for the first time, we welcome all year 4 children
                    and their families to come to Weekend Masses and enrol their child during the Advent Season
                </p>
                <h2 class="text-2xl font-semibold text-blue-800 my-6">Our Lady Queen of Martyrs & St Swithin’s First Holy Communion & Reconciliation Preparation 2026</h2>
                <p class="text-base text-black mb-6">
                    The preparation sessions will take place at 09:30 or 11:00 in the Community Room next to Church. The children can attend either session and must be accompanied by an adult.
                </p>
                <p class="text-base text-black mb-6">
                    Enrolment forms can be completed by a parent or carer, before or after any of the weekend Masses up until Christmas - 18:00 on Saturday and 11:30 on Sunday.
                </p>
                <div class="mb-6 space-y-1">
                    <p class="text-base font-semibold text-black">17/01/2026 – First Session</p>
                    <p class="text-base font-semibold text-black">07/02/2026 – Second Session</p>
                    <p class="text-base font-semibold text-black">07/03/2026 – Third Session</p>
                    <p class="text-base font-semibold text-black">18/04/2026 – Fourth Session – Sacrament of Reconciliation</p>
                    <p class="text-base font-semibold text-black">06/05/2026 – 17:00 – St Swithin’s Rehearsal</p>
                    <p class="text-base font-semibold text-black">09/05/2026 – 11:00 – St Swithin’s First Holy Communion Mass</p>
                    <p class="text-base font-semibold text-black">13/05/2026 – 17:00 – Emmaus Rehearsal</p>
                    <p class="text-base font-semibold text-black">16/05/2026 – 11:00 – Emmaus First Holy Communion Mass</p>
                </div>
                <p class="text-base text-black mb-6">
                    The children are expected to attend the sessions and if the child was not baptised at Our Lady Queen of Martyrs then proof of baptism will be needed. Thank you.
                </p>
                <div className="mt-16 w-full flex justify-center flex-col items-center space-y-6 sm:flex-row sm:space-y-0 sm:space-x-8">
                    <img
                        src="/pictures/IMG_5321.JPG"
                        alt="FHC 1"
                        className="w-60 h-60 object-cover rounded-xl shadow-md"
                    />
                    <img
                        src="/pictures/FHC_1.jpg"
                        alt="FHC 2"
                        className="w-60 h-60 object-cover rounded-xl shadow-md"
                    />
                    <img
                        src="/pictures/FHC_2.jpg"
                        alt="FHC 3"
                        className="w-60 h-60 object-cover rounded-xl shadow-md"
                    />
                </div>
            </div>
        </div>
    );
}